// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"O2","heading":"P2","item":"Q2","fadeIn":"R2","imagewrapper":"S2","modalheader":"T2","amount":"U2","name":"V2","desc":"W2","moredetails":"X2","ingheader":"Y2"};
    if(module.hot) {
      // 1730991512253
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  